import { render, staticRenderFns } from "./ConnectionIcon.vue?vue&type=template&id=22560186"
import script from "./ConnectionIcon.vue?vue&type=script&lang=js"
export * from "./ConnectionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports